<script lang="ts">
	import { onMount, onDestroy } from 'svelte';
	import ApexCharts from 'apexcharts';
	import type { ApexOptions } from 'apexcharts';

	/** ApexCharts options (series + config). Pass a new object to re-render. */
	export let options: ApexOptions;

	let el: HTMLDivElement;
	let chart: ApexCharts | null = null;

	onMount(() => {
		chart = new ApexCharts(el, options);
		chart.render();
	});

	onDestroy(() => {
		chart?.destroy();
		chart = null;
	});

	// Re-render when options change (after the initial mount).
	$: if (chart) {
		chart.updateOptions(options, false, true);
	}
</script>

<div bind:this={el}></div>
